var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        style: `height: calc(93vh - ${_vm.toolbarHeight}px); overflow: hidden;`,
        attrs: { id: "pdf-container", name: "pdf-container" },
      },
      [
        _c(
          "object",
          {
            staticClass: "pdf-document",
            staticStyle: { width: "100%", height: "100%" },
            attrs: { id: "pdfDoc", data: _vm.pdfUrl, type: "application/pdf" },
          },
          [
            _c("embed", {
              staticClass: "pdf-document",
              attrs: { src: _vm.pdfUrl, type: "application/pdf" },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }